import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50 pt-16 md:pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-12">
          <div className="md:max-w-xs">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 rounded-full bg-background-50/20 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading text-lg font-bold">OOPBuy Spreadsheet</span>
            </div>
            <p className="text-background-50/60 text-sm leading-relaxed">
              Der ultimative Einkaufsführer für Deutschland. Entdecke tausende geprüfte Produkte, vergleiche Verkäufer und spare Versandkosten.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Navigation</h4>
              <div className="space-y-2.5">
                <Link to="/" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">Startseite</Link>
                <a href="#vorteile" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">Vorteile</a>
                <a href="#faq" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">FAQ</a>
                <Link to="/artikel/oopbuy-spreadsheet-guide" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">Ratgeber</Link>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Rechtliches</h4>
              <div className="space-y-2.5">
                <Link to="/" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">Datenschutz</Link>
                <Link to="/" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">Impressum</Link>
                <Link to="/" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">Disclaimer</Link>
                <Link to="/" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">Kontakt</Link>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Top Kategorien</h4>
              <div className="space-y-2.5">
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">Shoes</a>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">Hoodies</a>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">Jackets</a>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="block text-sm text-background-50/60 hover:text-background-50 transition-colors">T-Shirts</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-background-50/50 font-heading">
            Qualität. Vertrauen. Community.
          </p>
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} OOPBuy Spreadsheet. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-background-50/50 hover:text-background-50 transition-colors text-sm">oopbuy spreadsheet</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-background-50/50 hover:text-background-50 transition-colors text-sm">buy it now</a>
          </div>
        </div>
      </div>
    </footer>
  );
}